import { FormLabels } from 'components/curo-components/forms/types';

export enum ApplyFormFields {
  BorrowerFirstName = 'borrowerFirstName',
  BorrowerLastName = 'borrowerLastName',
  BorrowerSSN = 'borrowerSSN',
  BorrowerDateOfBirth = 'borrowerDateOfBirth',
  BorrowerStreetAddress = 'borrowerStreetAddress',
  BorrowerCity = 'borrowerCity',
  BorrowerZipOrPostalCode = 'borrowerZipOrPostalCode',
  BorrowerState = 'borrowerState',
}

export interface IApplyFormValues {
  [ApplyFormFields.BorrowerFirstName]: string;
  [ApplyFormFields.BorrowerLastName]: string;
  [ApplyFormFields.BorrowerSSN]: string;
  [ApplyFormFields.BorrowerDateOfBirth]: string;
  [ApplyFormFields.BorrowerStreetAddress]: string;
  [ApplyFormFields.BorrowerCity]: string;
  [ApplyFormFields.BorrowerZipOrPostalCode]: string;
  [ApplyFormFields.BorrowerState]: string;
}

export const applyFormLabels: FormLabels<ApplyFormFields> = {
  [ApplyFormFields.BorrowerFirstName]: 'First Name',
  [ApplyFormFields.BorrowerLastName]: 'Last Name',
  [ApplyFormFields.BorrowerSSN]: 'SSN',
  [ApplyFormFields.BorrowerDateOfBirth]: 'Date of Birth',
  [ApplyFormFields.BorrowerStreetAddress]: 'Street Address',
  [ApplyFormFields.BorrowerCity]: 'City',
  [ApplyFormFields.BorrowerZipOrPostalCode]: 'Zip Code',
  [ApplyFormFields.BorrowerState]: 'State',
};

export const availableStates = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];
